export default __webpack_public_path__ + "static/media/Book7.f7167306.pdf";